import type { ReactElement } from "react";

import type { IconName } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import {
    StyledEmptyStateIcon,
    StyledSignalsEmptyImageBlock,
    StyledSignalsEmptySubTitle,
    StyledSignalsEmptyTitle,
    StyledSignalsEmptyViewWrapper,
} from "./styles";

interface ISignalsEmptyViewProps {
    titleKey: string;
    subtitleKey: string;
    iconName?: IconName;
    actionButton: ReactElement;
    dataAutomation?: string;
}

export const SignalsEmptyView = ({
    titleKey,
    subtitleKey,
    iconName = "no-data-lab",
    actionButton,
    dataAutomation = "signals-empty-view",
}: ISignalsEmptyViewProps) => {
    return (
        <StyledSignalsEmptyViewWrapper data-automation={dataAutomation}>
            <StyledSignalsEmptyImageBlock>
                <StyledEmptyStateIcon iconName={iconName} />
            </StyledSignalsEmptyImageBlock>
            <I18n
                element={StyledSignalsEmptyTitle}
                translatable={{ key: titleKey }}
            />
            <I18n
                element={StyledSignalsEmptySubTitle}
                translatable={{ key: subtitleKey }}
            />
            {actionButton}
        </StyledSignalsEmptyViewWrapper>
    );
};
